import type { MarcoAdvogado } from '../types';

const dataRelativa = (dias: number): string => {
  const data = new Date();
  data.setHours(12, 0, 0, 0);
  data.setDate(data.getDate() + dias);
  return data.toISOString();
};

export const buildMarcosCalendario = (): MarcoAdvogado[] => [
  {
    id: 'm-instrucao',
    categoria: 'MARCO_PROCESSO',
    tipo: 'FIM_FASE',
    titulo: 'Fim da fase de instrução',
    descricao: null,
    processoId: 'proc-001',
    processoReferencia: 'ARB-2026-00418',
    clienteNome: 'Ana Martins',
    data: dataRelativa(2),
    diasParaVencer: 2,
  },
  {
    id: 'm-documentacao',
    categoria: 'PENDENCIA',
    tipo: 'PENDENCIA_DOCUMENTACAO',
    titulo: 'Enviar documentos complementares',
    descricao: 'Procuração atualizada e comprovante de residência.',
    processoId: 'proc-001',
    processoReferencia: 'ARB-2026-00418',
    clienteNome: 'Ana Martins',
    data: dataRelativa(0),
    diasParaVencer: 0,
  },
  {
    id: 'm-pagamento',
    categoria: 'PENDENCIA',
    tipo: 'PENDENCIA_PAGAMENTO',
    titulo: 'Honorários da câmara',
    descricao: null,
    processoId: 'proc-004',
    processoReferencia: 'ARB-2026-00502',
    clienteNome: 'Diego Freitas',
    data: dataRelativa(-3),
    diasParaVencer: -3,
  },
  {
    id: 'm-sentenca',
    categoria: 'MARCO_PROCESSO',
    tipo: 'SENTENCA_PREVISTA',
    titulo: 'Sentença prevista',
    descricao: null,
    processoId: 'proc-001',
    processoReferencia: 'ARB-2026-00418',
    clienteNome: 'Ana Martins',
    data: dataRelativa(18),
    diasParaVencer: 18,
  },
];
